import React, { useEffect, useState } from "react";
import "./styles.scss";
import { Row, Col } from "react-bootstrap";
import { useHistory, useLocation } from "react-router-dom";
import { useFirestore } from "reactfire";
import PublicWorkshopsHeader from "../components/header/PublicWorkshopsHeader";
import CustomMenu from "../../../../../shared/components/CustomMenu/CustomMenu";
import { DashboardPublicLibraryViewPages } from "../../../containers/PublicLibraryView";
import { zeroPad } from "../../../../../shared/utils/Commons";

const SubMenuPublicWorkshops = () => {
  const history = useHistory();
  const { pathname } = useLocation();

  return (
    <div className="public-library-view-wrapper">
      <Row>
        <Col xs={12}>
          <PublicWorkshopsHeader />
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          <CustomMenu
            data={[
              {
                onClick: () => {
                  history.push(DashboardPublicLibraryViewPages.PUBLIC_HOME);
                },
                text: "Library Home",
                isActive:
                  pathname === DashboardPublicLibraryViewPages.PUBLIC_HOME,
              },
              {
                onClick: () => {
                  history.push(
                    DashboardPublicLibraryViewPages.PUBLIC_WORKSHOPS
                  );
                },
                text: "Workshops",
                isActive:
                  pathname === DashboardPublicLibraryViewPages.PUBLIC_WORKSHOPS,
                expandableData: <WorkshopsMenu />,
              },
            ]}
          />
        </Col>
      </Row>
    </div>
  );
};

interface Workshop {
  id: string;
  title: string;
  description: string;
  createdAt: Date;
  orderNo: number;
}

const WorkshopsMenu = () => {
  const [workshops, setWorkshops] = useState<Workshop[]>([]);
  const store = useFirestore();
  const [fWorkshops, setFWorkshops] = useState<Workshop[]>([]);
  useEffect(() => {
    setFWorkshops((ps) => {
      return workshops.sort(
        (a: Workshop, b: Workshop) => a.orderNo - b.orderNo
      );
    });
  }, [workshops]);

  useEffect(() => {
    return store
      .collection("publicWorkshops")
      .where("active", "==", true)
      .onSnapshot({}, (snapshot) => {
        snapshot.docChanges().forEach((change) => {
          if (change.type === "added") {
            console.log("data:", change.doc.data());
            setWorkshops((ps) => {
              ps.push({
                id: change.doc.id,
                title: change.doc.data().title,
                description: change.doc.data().description,
                createdAt: change.doc.data().createdAt,
                orderNo: change.doc.data().orderNo,
              });
              return Object.assign([], ps);
            });
          }
          if (change.type === "modified") {
            setWorkshops((ps) => {
              const modified = ps.map((a) => {
                if (a.id === change.doc.id) {
                  return {
                    id: change.doc.id,
                    title: change.doc.data().title,
                    description: change.doc.data().description,
                    createdAt: change.doc.data().createdAt,
                    orderNo: change.doc.data().orderNo,
                  };
                } else {
                  return a;
                }
              });
              return Object.assign([], modified);
            });
          }
          if (change.type === "removed") {
            setWorkshops((ps) => {
              const removed = ps.filter((a) => a.id !== change.doc.id);
              return Object.assign([], removed);
            });
          }
        });
      });
  }, [store]);

  return (
    <div className="public-subsections-menu-wrapper">
      <ul>
        {fWorkshops.map((work, index) => (
          <WorkshopMenuItem
            title={`${zeroPad(index + 1, 2)}. ${work.title}`}
            workshopId={work.id}
            key={index}
          />
        ))}
      </ul>
    </div>
  );
};

interface IPropsSMI {
  completed?: boolean;
  title: string;
  workshopId: string;
}

const WorkshopMenuItem = (props: IPropsSMI) => {
  const { push } = useHistory();
  return (
    <li
      onClick={() => {
        push(`/workshop/${props.workshopId}`);
      }}
    >
      <div className="sub-title">{props.title}</div>
    </li>
  );
};

export default SubMenuPublicWorkshops;
